// extracted by mini-css-extract-plugin
export default {"container":"UnexpectedError_container__BQDxr","home":"UnexpectedError_home__KwaQl"};